module.exports = __webpack_public_path__ + "media/images/ohap_question_bank_off-657e6a3a57f1ab550e15d1e289d886eb.png";